import { useCallback } from 'react'
import { useSearchParams } from 'react-router-dom'

const useQuery = () => {
  const [searchParams, setSearchParams] = useSearchParams()

  const setQuery = useCallback(
    (key: string, value: any) => {
      setSearchParams((prevSearchParams) => {
        const newSearchParams = new URLSearchParams(prevSearchParams)
        newSearchParams.set(
          key,
          typeof value === 'object' ? JSON.stringify(value) : value,
        )
        return newSearchParams
      })
    },
    [setSearchParams],
  )

  const setMultipleQueries = (queryParams: Record<string, any>) => {
    setSearchParams((prevSearchParams) => {
      const newSearchParams = new URLSearchParams(prevSearchParams)

      Object.entries(queryParams).forEach(([key, value]) => {
        newSearchParams.set(
          key,
          typeof value === 'object' ? JSON.stringify(value) : value,
        )
      })

      return newSearchParams
    })
  }

  const getQuery = useCallback(
    (key: string) => {
      const value = searchParams.get(key)
      try {
        return value ? JSON.parse(value) : null
      } catch (error) {
        return value
      }
    },
    [searchParams],
  )

  const removeQuery = useCallback(
    (key: string) => {
      setSearchParams((prevSearchParams) => {
        const newSearchParams = new URLSearchParams(prevSearchParams)
        newSearchParams.delete(key)
        return newSearchParams
      })
    },
    [setSearchParams],
  )

  const getAllQueries = useCallback(() => {
    const queries: any = {}

    searchParams.forEach((value, key) => {
      try {
        queries[key] = JSON.parse(value)
      } catch (error) {
        queries[key] = value
      }
    })
    return queries
  }, [searchParams])

  return { setQuery, getQuery, removeQuery, getAllQueries, setMultipleQueries }
}

export default useQuery
